module.exports = __webpack_public_path__ + "static/media/areamap11.c5c8b046.svg";